<template>
    <div>
        <product-relations-list></product-relations-list>
        <product-entity-relations-list></product-entity-relations-list>
    </div>
</template>

<script>
import ProductRelationsList from "./product-relations-list.vue";
import ProductEntityRelationsList from "./product-entity-relations-list.vue";

export default {
    name: "product-relations",
    components: {
        "product-relations-list": ProductRelationsList,
        "product-entity-relations-list": ProductEntityRelationsList
    }
};
</script>

<style lang="scss">
.channel-status-column {
    width: 160px;
}

.list-label {
    margin: 10px 0;
    font-size: 17px;
}
</style>
